import { Component } from '@angular/core';

@Component({
  selector: 'app-own-services',
  templateUrl: './own-services.component.html',
  styleUrls: ['./own-services.component.scss']
})
export class OwnServicesComponent {

}
